// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: registration => {
    // When an update is available, show a prompt to the user
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener('statechange', event => {
        if (event.target.state === 'activated') {
          // Reload the page when the new service worker is activated
          window.location.reload();
        }
      });

      // You could show a notification here asking the user to update
      if (window.confirm('A new version of Iyewo is available! Click OK to update.')) {
        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      }
    }
  },
  onSuccess: () => {
    console.log('Iyewo is ready for offline use!');
  }
});